import React, { useEffect, useRef, useState, useCallback } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import './index.scss';
import VehicleCard from './components/VehicleCard';
import { RootState } from '@/redux/store';
import BussinessApi from '@/fetch/bussiness';
import CollectMapApi from '@/fetch/bussiness/collectMap';
import {
  CockpitMode,
  IssueDrawerData,
  IssueStatus,
  MapVehicleListResponse,
  VehicleLitResponse,
} from '@/utils/type';
import { HttpStatusCode } from '@/fetch/core/constant';
import { getClstag, isEmpty } from '@/utils/util';
import { Pagination } from 'antd';
import classNames from 'classnames';
import DebounceSearch from '@/components/DebounceSearch';
import { useNavigate } from 'react-router-dom';
import { debounce } from '@/utils/util';
import { sendGlobalEvent } from '@/utils/emit';
const requestApi = new BussinessApi();
const collectMapApi = new CollectMapApi();
const MultiVehicle = () => {
  const navigator = useNavigate();
  const videoUrlMap = useRef<any>({});
  const collectVideoUrlMap = useRef<any>({});
  const newCommon = useSelector(
    (state: RootState) => state.newCommon,
    shallowEqual
  );
  const controlBtn = useSelector(
    (state: RootState) => state.controlBtn,
    shallowEqual
  );
  const issue = useSelector((state: RootState) => state.issue, shallowEqual);
  const { cockpitNumber, cockpitMode } = newCommon;
  const [curIndex, setCurIndex] = useState<number>(0);
  const [tableData, setTableData] = useState<
    VehicleLitResponse[] | MapVehicleListResponse[]
  >([]);
  const containerRef = useRef(null);
  const [pagination, setPagination] = useState<{
    total: number;
    pageNum: number;
    pageSize: number;
    pages: number;
    scheduleVehicleCount: number;
  }>({
    total: 0,
    pageNum: 1,
    pageSize: 8,
    pages: 0,
    scheduleVehicleCount: 0,
  });
  useEffect(() => {
    return () => {
      if (containerRef.current) {
        // 1. 先将内容置空，这有助于 React 释放内部 Fiber 引用
        // 2. 强制切断所有子节点与容器的关系
        const container = containerRef.current;

        container.innerHTML = '';
        // 移除所有子元素，彻底断开引用
        while (container.firstChild) {
          container.removeChild(container.firstChild);
        }

        // 显式将引用设为 null
        videoUrlMap.current = {};
        collectVideoUrlMap.current = {};
        if (window.performance && window.performance.clearResourceTimings) {
          window.performance.clearResourceTimings();
        }
      }
    };
  }, []);
  const getMapVehicleList = useCallback(async () => {
    try {
      const res = await collectMapApi.getVehiclePage({
        pageSize: pagination.pageSize,
        pageNum: pagination.pageNum,
      });
      if (res.code === HttpStatusCode.Success) {
        setTableData(res?.data?.list || []);
        setPagination((prev) => ({
          ...prev,
          total: res?.data?.total || 0,
          pages: res?.data?.pages || 0,
        }));
      }
    } catch (err) {
      // error handling
      console.error(err);
    }
  }, [pagination.pageSize, pagination.pageNum]);

  const getVehicleList = useCallback(async () => {
    try {
      const res = await requestApi.getVehicleList({
        cockpitNumber,
        pageNum: pagination.pageNum,
        pageSize: pagination.pageSize,
      });
      if (res.code === HttpStatusCode.Success) {
        setTableData(res?.data?.list || []);
        setPagination((prev) => ({
          ...prev,
          total: res?.data?.total || 0,
          pages: res?.data?.pages || 0,
          scheduleVehicleCount: res?.data?.scheduleVehicleCount,
        }));
      }
    } catch (e) {
    } finally {
    }
  }, [cockpitNumber, pagination.pageSize, pagination.pageNum]);

  useEffect(() => {
    if (!newCommon.cockpitNumber || !newCommon.cockpitMode) {
      return;
    }

    const fetchData = () => {
      if (newCommon.cockpitMode !== CockpitMode.MAP_COLLECTION_MODE) {
        getVehicleList();
      } else {
        getMapVehicleList();
      }
    };

    fetchData();
    const intervalId = setInterval(fetchData, 5000); // Polling is commented out by user

    return () => {
      clearInterval(intervalId);
    };
  }, [
    pagination.pageNum,
    pagination.pageSize,
    pagination.total,
    newCommon.cockpitNumber,
    newCommon.cockpitMode,
  ]);

  useEffect(() => {
    const vehicleNameList = tableData?.map((item: any) => item.vehicleName);
    if (newCommon.cockpitMode === CockpitMode.MAP_COLLECTION_MODE) {
      const hasNoUrlList = vehicleNameList?.filter((item: string) => {
        const url = collectVideoUrlMap.current[item];
        return !url;
      });
      if (hasNoUrlList.length === 0) {
        return;
      }
      getCollectVideoUrl(vehicleNameList);
    } else {
      const hasNoUrlList = vehicleNameList?.filter((item: string) => {
        const url = videoUrlMap.current[item];
        return !url;
      });
      if (hasNoUrlList.length === 0) {
        return;
      }
      getVideoUrl(hasNoUrlList);
    }
  }, [
    tableData?.map((item: any) => item.vehicleName).toString(),
    newCommon.cockpitMode,
  ]);

  useEffect(() => {
    formatActiveIndex(
      controlBtn.LC_BUTTON_UP,
      controlBtn.LC_BUTTON_DOWN,
      controlBtn.LC_BUTTON_LEFT,
      controlBtn.LC_BUTTON_RIGHT
    );
  }, [
    controlBtn.LC_BUTTON_UP,
    controlBtn.LC_BUTTON_DOWN,
    controlBtn.LC_BUTTON_LEFT,
    controlBtn.LC_BUTTON_RIGHT,
  ]);

  const formatActiveIndex = (
    up: boolean,
    down: boolean,
    left: boolean,
    right: boolean
  ) => {
    if (left) {
      setCurIndex(curIndex > 0 ? curIndex - 1 : 0);
    } else if (right) {
      setCurIndex(curIndex < tableData?.length - 1 ? curIndex + 1 : 0);
    } else if (up) {
      if (pagination.pageSize < 8) {
        // 一页小于8个只有一行
        return;
      }
      if (curIndex > pagination.pageSize / 2 - 1) {
        // 在第二行
        setCurIndex(curIndex - 4); // 上下移动步长为4
      }
    } else if (down) {
      if (pagination.pageSize < 8) {
        // 一页小于8个只有一行
        return;
      }
      if (curIndex <= pagination.pageSize / 2 - 1) {
        // 在第一行
        setCurIndex(curIndex + 4); // 上下移动步长为4
      }
    }
  };
  const getCollectVideoUrl = async (vehicleNameList: any[]) => {
    if (!isEmpty(vehicleNameList)) {
      collectMapApi.getVideoUrlList({ vehicleNameList }).then((res) => {
        res?.data?.forEach((item: any) => {
          collectVideoUrlMap.current[item.vehicleName] = item;
        });
      });
    }
  };
  const getVideoUrl = async (vehicleNameList: any[]) => {
    if (!isEmpty(vehicleNameList)) {
      requestApi.getVideoUrlList(vehicleNameList).then((res) => {
        res?.data?.forEach((item: any) => {
          videoUrlMap.current[item.carId] = item.front;
        });
      });
    }
  };

  const changePageSize = (num: number) => {
    setPagination({
      ...pagination,
      pageSize: num,
      pageNum: 1,
    });
  };

  useEffect(() => {
    if (controlBtn.LC_BUTTON_ENTER) {
      if (cockpitMode === CockpitMode.PATROL_MODE) {
        return;
      }
      const active = tableData[curIndex];
      if (!active) {
        return;
      }
      navigator(`/app/singleview?vehicleName=${active.vehicleName}`);
    }
  }, [controlBtn.LC_BUTTON_ENTER, curIndex]);

  useEffect(() => {
    if (controlBtn.LC_BUTTON_L1) {
      setPagination({
        ...pagination,
        pageNum: pagination.pageNum > 1 ? pagination.pageNum - 1 : 1,
      });
    } else if (controlBtn.LC_BUTTON_R1) {
      setPagination({
        ...pagination,
        pageNum:
          pagination.pageNum < pagination.pages
            ? pagination.pageNum + 1
            : pagination.pages,
      });
    }
  }, [controlBtn.LC_BUTTON_L1, controlBtn.LC_BUTTON_R1]);

  useEffect(() => {
    if (controlBtn.LC_BUTTON_MINUS) {
      debounce(() => {
        sendGlobalEvent('QUIT_COCKPIT');
      }, 500)();
    }
  }, [controlBtn.LC_BUTTON_MINUS]);

  return (
    <div ref={containerRef} className="remote-driver-container">
      <ul className="vehicle-info-container">
        {tableData?.map(
          (
            item: VehicleLitResponse | MapVehicleListResponse,
            index: number
          ) => {
            return (
              <VehicleCard
                key={item.vehicleName}
                vehicleData={item}
                url={videoUrlMap.current[item.vehicleName]}
                collectVideoUrl={collectVideoUrlMap.current[item.vehicleName]}
                cockpitMode={newCommon.cockpitMode}
                handleUpdate={getVehicleList}
                isActive={curIndex === index}
              />
            );
          }
        )}
      </ul>
      <div className="footer-region">
        <div className="field-item">
          <i className="label">选择车辆 </i>
          <i className="bold-label">{tableData[curIndex]?.vehicleName}</i>
        </div>
        <div className="field-item">
          <i className="label">任务中车辆</i>
          <i className="bold-label">{pagination.scheduleVehicleCount}</i>
        </div>
        <div
          className="search-bar"
          clstag={getClstag(newCommon.cockpitMode, 'MultiPage_SearchVehicle')}
        >
          <DebounceSearch
            placeholder="搜索站点/车号"
            cockpitNumber={cockpitNumber}
            onChange={(data: any) => {
              data.value &&
                navigator(`/app/singleview?vehicleName=${data.value}`);
            }}
            cockpitMode={newCommon.cockpitMode}
          />
        </div>
        <Pagination
          size="small"
          total={pagination.total}
          pageSize={pagination.pageSize}
          current={pagination.pageNum}
          showSizeChanger={false}
          showQuickJumper={false}
          onChange={(page, pageSize) => {
            setPagination({
              ...pagination,
              pageNum: page,
              pageSize,
            });
          }}
        />
        <div className="pagesize-btns">
          <div className="btn-box">
            <i className="label">分页方式</i>
            {[2, 4, 8].map((num) => (
              <i
                key={num}
                className={classNames('pagesize-item', {
                  active: num == pagination.pageSize,
                })}
                onClick={() => {
                  changePageSize(num);
                }}
                clstag={getClstag(
                  newCommon.cockpitMode,
                  `MultiPage_Pagination_${num}`
                )}
              >
                {num}
              </i>
            ))}
          </div>
          <div className="page-num">
            第{pagination.pageNum}页/共{pagination.pages}页
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(MultiVehicle);
